<template>
  <v-container fluid style="overflow: hidden !important;">
   <v-layout row wrap >  
      <v-flex sm12 md12 lg12 xl12 >
        <div class="chatboxnonselect">
          <v-layout align-center justify-center row fill-height>
            <img src='/static/img/pagedefault/notfound.jpg' width="400" >
          </v-layout>
        </div>
      </v-flex>
      </v-layout>
      </v-container>
</template>

<script>
import { Decode } from '@/services'

export default {
  data () {
    return {
      status_login: ''
    }
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.status_login = decoded['status_login']
  }
}
</script>
<style type="text/css" scoped>
.container{
  padding: 0px !important;
}
.fixed-content {
    min-height:100%;
    /*position:fixed;*/
    overflow-y:scroll;
    overflow-x:hidden;
}
.content {
      padding: 0px 0px 0px !important;
}
>>>.chatboxnonselect{
    width: 100%;
    min-width: 10vw;
    height: calc(100vh - 64px);
    background-color:white;
    overflow-y: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/chat/pagedefault/NotFound.vue